import { Language } from './types';

const BASE_EN_LANGUAGE_LABELS = {
  aiAccountType: 'Account type',
  aiSavings: 'Savings account',
  aiClabeNumber: 'CLABE number',
  aiFundsToAdd: 'Funds to add',
  aiFundsToAddDisclaimer:
    'Use these instructions to add funds to your EFEX account from any external bank account.',
  aiFinturuTransferMethod: 'Transfer Method',
  aiFinturuReceipt: 'Beneficiary',
  aiFinturuRoutingNumber: 'Routing Number',
  aiFinturuRoutingNumberAch: 'Routing Number (ACH)',
  aiFinturuRoutingCodeACH: 'ACH (Routing Number)',
  aiFinturuRoutingCodeWire: 'Wire (Routing Number)',
  aiFinturuAccount: 'Account Number',
  aiFinturuAccountType: 'Account type',
  aiFinturuBankName: 'Receiving Bank',
  aiFinturuBankAddress: 'Bank Address',
  aiDownloadButton: 'Download PDF',
  aiSwiftCode: 'Swift Code',
  aiSwiftCodeMessage: 'If you want to receive an international payment, add:',
  aiMethodFEDWIRE: 'Fedwire',
};

type LabelsLanguage = keyof typeof BASE_EN_LANGUAGE_LABELS;

const PAYMENT_INVOICE_LANGUAGE_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_EN_LANGUAGE_LABELS,
  ES: {
    aiAccountType: 'Tipo de cuenta',
    aiSavings: 'Cuenta de ahorros',
    aiClabeNumber: 'Cuenta CLABE',
    aiFundsToAdd: 'Fondos a transferir',
    aiFundsToAddDisclaimer:
      'Utilice estas instrucciones para añadir fondos a su cuenta EFEX desde cualquier cuenta bancaria externa.',
    aiFinturuTransferMethod: 'Método de transferencia',
    aiFinturuReceipt: 'Beneficiario',
    aiFinturuRoutingNumber: 'Número de routing',
    aiFinturuRoutingNumberAch: 'Número de routing (ACH)',
    aiFinturuRoutingCodeACH: 'ACH (Número Routing)',
    aiFinturuRoutingCodeWire: 'Wire (Número Routing)',
    aiFinturuAccount: 'Número de cuenta',
    aiFinturuAccountType: 'Tipo de cuenta',
    aiFinturuBankName: 'Banco receptor',
    aiFinturuBankAddress: 'Dirección del Banco',
    aiDownloadButton: 'Descargar PDF',
    aiSwiftCode: 'Código Swift',
    aiSwiftCodeMessage: 'Si desea recibir un pago internacional, agregue:',
    aiMethodFEDWIRE: 'Fedwire',
  },
};

export default PAYMENT_INVOICE_LANGUAGE_LABELS;
